'use client';
import { useMemo } from 'react';
import toast from 'react-hot-toast';

import { useAdminUser } from '@/hooks';
import logger from '@/services/logger/getLogger';
import { generatePaymentLink } from '@/utils/payment';

export const PaymentLink = () => {
  const { adminUser } = useAdminUser();
  const paymentLink = useMemo(() => {
    return generatePaymentLink(adminUser?.adminId, [
      'utm_source=magento',
      'utm_medium=atendimento_televendas',
      'utm_campaign=vendedores'
    ]);
  }, [adminUser?.adminId]);

  const handleCopyLink = async () => {
    try {
      await navigator.clipboard.writeText(paymentLink);
      toast.success('Link de pagamento copiado!');
    } catch (error) {
      toast.error('Falha ao copiar o link de pagamento.');
      logger.error('Error copying payment link:', error);
    }
  };

  return (
    <div className="mt-2 flex flex-col md:flex-row items-center w-full md:w-auto gap-2">
      <input
        name="paymentLink"
        readOnly
        value={paymentLink}
        className="w-full md:w-[300px] p-2 rounded text-primary-darkest text-sm"
      />
      <button
        className="w-full md:w-auto bg-white text-primary-darkest text-sm px-2 py-2 rounded transition-colors"
        onClick={handleCopyLink}
      >
        Copiar link de pagamento
      </button>
    </div>
  );
};
